require('./lbFareRulesRailModal.scss');

const lbFareRulesRailModal = angular.module('app.lbFareRulesRailModal', []);

lbFareRulesRailModal.component('lbFareRulesRailModal', {
  controllerAs: 'vm',
  controller: ['lbModalService', '$scope', controller],
  template: require('./lbFareRulesRailModal.html'),
});

function controller(lbModalService, $scope) {
  let vm = this;

  const params = lbModalService.params();
  const urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

  vm.carrierName = params.trip.CarrierName;
  vm.rulesType = params.fareRules.Type;
  vm.fareRulesText = params.fareRules.Data;

  $scope.setActiveTab = function (selectedTab) {
    angular.forEach($scope.tabs, function (tab) {
      tab.active = tab === selectedTab;
    });
  };

  if (params.fare) {
    vm.fareInfo = {
      FareBasis: params.fare.Code.filter(onlyUnique),
      ResBookDesignCode: params.fare.ResBookDesignCode.filter(onlyUnique),
    };
  }

  function parseStringToObjects(inputString) {
    const createObject = (title, content, active) => {
      return {
        title,
        content: content.join('\n').trim(),
        active,
      };
    };

    const fareDetailsContent = [
      '<b>FARE BASIS</b> <BR><BR>',
      vm.fareInfo.FareBasis,
      '<BR><BR><b> RESERVATION CLASS OF SERVICE</b> <BR><BR>',
      vm.fareInfo.ResBookDesignCode,
      '<BR><BR><b> FARE RULES</b> <BR><BR>',
      inputString.trim().split('\n'),
    ];

    const result = [];
    result.push(createObject('FARE DETAILS', fareDetailsContent, true));

    return result;
  }

  $scope.tabs = parseStringToObjects(vm.fareRulesText);

  if (vm.rulesType === 'ExternalUrl') {
    vm.fareRulesText = vm.fareRulesText.replace(urlReg, replaceLink);
  }

  function replaceLink(str) {
    return '<a href="' + str + '" target="_blank" rel="noreferrer noopener">' + 'Click here to view fare rules' + '</a>';
  }

  vm.close = lbModalService.resolve;
  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }
}

export default lbFareRulesRailModal;



// WEBPACK FOOTER //
// ./src/components/lbFareRulesRailModal/lbFareRulesRailModal.js